module.exports = __webpack_public_path__ + "media/home/SeeUsInMotion-dbc47743.png";